import { render, staticRenderFns } from "./CollectionLinkedFilePreview.vue?vue&type=template&id=dba37ac2&scoped=true"
import script from "./CollectionLinkedFilePreview.vue?vue&type=script&lang=js"
export * from "./CollectionLinkedFilePreview.vue?vue&type=script&lang=js"
import style0 from "./CollectionLinkedFilePreview.vue?vue&type=style&index=0&id=dba37ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba37ac2",
  null
  
)

export default component.exports